









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { SurveyWhole } from '@/pages/simple-survey/entities/survey'

@Component<CompleteSurveyPrompt>({
    components: {}
})
export default class CompleteSurveyPrompt extends Vue {
    @Prop({ type: Object, required: true })
    public readonly draftSurvey!: SurveyWhole

    public redirectTo() {
        window.location.pathname = `/survey/${this.draftSurvey.id}/review-and-activate`
    }
}
